import { Component, Input, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import {MatLegacyPaginator as MatPaginator} from '@angular/material/legacy-paginator';
import { EnvService } from '../services/env.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { debounceTime } from 'rxjs';
import { SettingsPersistenceService } from '../services/settings-persistence.service';
import { AuthService } from '../services/auth.service';
import { CmdbServerRequestFilter } from './cmdb-server-requests.filter';

@Component({
  selector: 'micro-cmdb-server-requests',
  templateUrl: './cmdb-server-requests.component.html',
})
export class CmdbServerRequestsComponent {
  @Input() hardwareRequestId?: string;

  dataSource = new MatTableDataSource<any>();

  @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
  pageSettings!: SettingsPersistenceService;
  filter = new CmdbServerRequestFilter();

  constructor(public auth: AuthService, private env: EnvService, private http: HttpClient) {
  }

  ngOnInit(): void {
    // Setup the settings persistence service for this page
    this.pageSettings = new SettingsPersistenceService(sessionStorage, 'micro.serverRequest');
    this.pageSettings
      .setFilter(this.filter)
      .setPaginator(this.paginator)
      .init();

    // Subscribe to filter changes with a debounce time to avoid excessive reloads
    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.reload();
    });

    // If the user is not a host company, set the companyId filter to the user's companyId ?
    // if (!this.auth.isHostCompany()) {
    //   this.filter.companyId = this.auth.getCompanyId();
    // }

    // Initial data load
    this.reload();
  }

  ngOnDestroy(): void {
  }

  reload(): void {
    let params: HttpParams = this.filter.getParams()
      .set('page', String(this.paginator.pageIndex || 0))
      .set('size', String(this.paginator.pageSize || 20));

    if (this.hardwareRequestId !== undefined) {
      params = params.set('requestId', String(this.hardwareRequestId));
    }

    this.http.get(`${this.env.e.url}/domain/cmdbServerRequests`, {params}).subscribe(data => {
      const page = data as any;
      this.dataSource.data = page.content;
      this.paginator.pageIndex = page.number;
      this.paginator.pageSize = page.size;
      this.paginator.length = page.totalElements;
    });
  }
}
